<template>
  <div>
    <div class="banner">
      <img :src="banner" v-if="clientWidth > 768" />
      <img :src="banner_m" v-else />
    </div>
    <div class="tabs">
      <div class="content">
        <div :class="active === index ? 'tab tab_active' : 'tab'" v-for="(item, index) in tabs" :key="item.id"
          @click="tabChange(item, index)">
          <div class="tab_content">
            <el-image class="icon" fit="contain" :src="active === index ? item.icon_active : item.icon"></el-image>
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="module">
      <div class="content">
        <div class="cards" v-if="clientWidth > 768">
          <div class="card" v-show="item.introduction" v-for="(item, index) in cards" :key="index">
            <div class="card_bg">
              <img :src="Res_Url + '/exhibition/new_block.png'">
            </div>
            <div :id="item.title" class="title" v-html="item.title.split('\n').join('<br>')"></div>
            <div class="info">
              <div class="introduction" v-html="item.introduction.split('\n').join('<br>')"></div>
              <div class="info_btns"
                v-if="item.pdf_url || item.question || item.linkUrl || (item.audio && Object.keys(item.audio).length > 0)">
                <div class="info_btn download" v-if="item.linkUrl" @click="handleLink(item)"
                  v-ga="{ event: 'trk', ec: 'discrete', ea: 'visit' }">
                  {{ item.linkTitle }}
                </div>
                <div class="info_btn download" v-if="item.pdf_url" @click="download(item)"
                  v-ga="{ event: 'trk', ec: 'product', ea: 'pdf' }">
                  PDF 下载 <el-image :src="imgs.download"></el-image>
                </div>
                <div class="info_btn exam" v-if="item.question" @click="toExam(item)"
                  v-ga="{ event: 'trk', ec: 'products', ea: 'quiz' }">
                  小问答 <el-image :src="imgs.exam"></el-image>
                </div>
                <!-- <div :class="item.audio.play ? 'playing' : 'pause'" class="info_btn" v-if="item.audio"
                  @click="playAudio(index, item.audio.play, item.audio.time)"
                  v-ga="{ event: 'trk', ec: 'products', ea: 'audioplay' }">
                  语音导览 <el-image :src="item.audio.play ? imgs.play : imgs.pause"></el-image>
                </div> -->
              </div>
              <el-collapse-transition>
                <div class="data" v-show="activeShow === index">
                  <div v-if="item.data.length == 1">
                    <img :title="item.title" v-if="item.data[0].type === 'image'"
                      :src="Res_Url2026 + '/cloudGuide/' + item.data[0].content" @click="imgPreview(item.data[0])" />
                    <div class="video" v-if="item.data[0].type === 'video'">
                      <video ref="video" :src="item.data[0].content"
                        :poster="Res_Url2026 + '/exhibition/新品展示所有视频的封面.png'"></video>
                      <img :src="Res_Url + '/exhibition/play.png'" alt="" @click="videoPlay(item.data[0])" />
                    </div>
                  </div>
                  <div v-else>
                    <swiper :options="swiperOption" ref="mySwiper" :auto-play="true" class="data_swiper_box">
                      <div class="swiper-button-prev s-prev" slot="button-prev"></div>
                      <div class="swiper-button-next s-next" slot="button-next"></div>
                      <swiper-slide class="data_swiper" v-for="(sub, subIndex) in item.data" :key="subIndex">
                        <div class="unit">
                          <img v-if="sub.type === 'image'" :src="Res_Url2026 + '/cloudGuide/' + sub.content" alt=""
                            @click="imgPreview(sub)" />
                          <div class="video" v-if="sub.type === 'video'">
                            <video ref="video" :src="sub.content"
                              :poster="Res_Url2026 + '/exhibition/新品展示所有视频的封面.png'"></video>
                            <img :src="Res_Url + '/exhibition/play.png'" alt="" @click="videoPlay(sub)" />
                          </div>
                          <div class="title">{{ sub.title }}</div>
                        </div>
                      </swiper-slide>
                    </swiper>
                    <div class="pages" v-if="item.data.length > 0">
                      <img :src="Res_Url + '/exhibition/line_left.png'" alt="" />
                      {{ pageIndex }}/{{ item.data.length }}
                      <img :src="Res_Url + '/exhibition/line_right.png'" alt="" />
                    </div>
                  </div>
                </div>
              </el-collapse-transition>
            </div>
            <div :style="item.data.length === 0 ? 'display: none' : ''" class="btn" @click="isShow(item, index)"
              v-ga="{ event: 'trk', ec: 'products', ea: 'authorization' }">
              {{ activeShow === index ? "收起" : "展开" }}
              <el-image :class="activeShow === index ? 'arrow_up' : 'arrow_down'" :src="imgs.arrow_up"></el-image>
            </div>
          </div>
        </div>
        <div class="cards" v-else>
          <div class="card_m" v-show="item.introduction" v-for="(item, index) in cards" :key="index">
            <div class="head">
              <!-- :style="item.data.length === 0 ? 'width:100%' : ''" -->
              <div :id="item.title" class="title" v-html="item.title.split('\n').join('<br>')"></div>

              <!-- :style="item.data.length === 0 ? 'display: none' : ''" -->
              <div class="btn" v-ga="{ event: 'trk', ec: 'products', ea: 'authorization' }"
                @click="isShow(item, index)">
                {{ activeShow === index ? "收起" : "展开" }}
                <el-image :class="activeShow === index ? 'arrow_up' : 'arrow_down'" :src="imgs.arrow_up"></el-image>
              </div>
            </div>
            <div :class="activeShow === index
              ? 'introduction'
              : 'introduction introduction_low'
              " v-html="item.introduction.split('\n').join('<br />')"></div>
            <div class="info_btns"
              v-if="item.pdf_url || item.question || item.linkUrl || (item.audio && Object.keys(item.audio).length > 0)">
              <div class="info_btn download" v-if="item.linkUrl" @click="handleLink(item)"
                v-ga="{ event: 'trk', ec: 'discrete', ea: 'visit' }">
                {{ item.linkTitle }}
              </div>
              <div class="info_btn download" v-if="item.pdf_url" @click="download(item)"
                v-ga="{ event: 'trk', ec: 'product', ea: 'pdf' }">
                PDF 下载 <el-image :src="imgs.download"></el-image>
              </div>
              <div class="info_btn exam" v-if="item.question" @click="toExam(item)">
                小问答 <el-image :src="imgs.exam"></el-image>
              </div>
              <!-- <div :class="item.audio.play ? 'playing' : 'pause'" class="info_btn" v-if="item.audio"
                @click="playAudio(index, item.audio.play, item.audio.time)"
                v-ga="{ event: 'trk', ec: 'products', ea: 'audioplay' }">
                语音导览 <el-image :src="item.audio.play ? imgs.play : imgs.pause"></el-image>
              </div> -->
            </div>
            <el-collapse-transition>
              <div class="data" v-show="activeShow === index">
                <div v-if="item.data.length == 1">
                  <img v-if="item.data[0].type === 'image'" :src="Res_Url2026 + '/cloudGuide/' + item.data[0].content"
                    @click="imgPreview(item.data[0])" />
                  <div class="video" v-if="item.data[0].type === 'video'">
                    <video ref="video" :src="item.data[0].content"
                      :poster="Res_Url2026 + '/exhibition/新品展示所有视频的封面.png'"></video>
                    <img :src="Res_Url + '/exhibition/play.png'" alt="" @click="videoPlay(item.data[0])" />
                  </div>
                </div>
                <div v-else>
                  <swiper :options="swiperOption" ref="mySwiper" :auto-play="true" class="data_swiper_box">
                    <div class="swiper-button-prev s-prev" slot="button-prev"></div>
                    <div class="swiper-button-next s-next" slot="button-next"></div>
                    <swiper-slide class="data_swiper" v-for="(sub, subIndex) in item.data" :key="subIndex">
                      <div class="unit">
                        <img v-if="sub.type === 'image'" :src="Res_Url2026 + '/cloudGuide/' + sub.content" alt=""
                          @click="imgPreview(sub)" />
                        <div class="video" v-if="sub.type === 'video'">
                          <video ref="video" :src="sub.content"
                            :poster="Res_Url2026 + '/exhibition/新品展示所有视频的封面.png'"></video>
                          <img :src="Res_Url + '/exhibition/play.png'" alt="" @click="videoPlay(sub)" />
                        </div>
                        <div class="title">{{ sub.title }}</div>
                      </div>
                    </swiper-slide>
                  </swiper>
                  <div class="pages" v-if="item.data.length > 0">
                    <img :src="Res_Url + '/exhibition/line_left.png'" alt="" />
                    {{ pageIndex }}/{{ item.data.length }}
                    <img :src="Res_Url + '/exhibition/line_right.png'" alt="" />
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </div>
        </div>
      </div>
    </div>

    <transition name="el-fade-in">
      <div v-show="video_box_show" class="video-box">
        <div class="content">
          <div class="video">
            <iframe id="cciframe_503DC188EBBE36BEF3342D97BB1D6DF8" :src="currentVideo" v-if="currentVideo != ''"
              frameborder="0" allowfullscreen></iframe>
            <!-- <i class="el-icon-circle-close" @click="boxClose"></i> -->
            <span class="question-close" @click="boxClose">×</span>
          </div>
        </div>
      </div>
    </transition>
    <transition name="el-fade-in">
      <div v-show="img_box_show" class="img_box">
        <div class="content content-img">
          <div class="img">
            <img :src="currentImg ? Res_Url2026 + '/cloudGuide/' + currentImg : ''" alt="" />
            <!-- <i class="el-icon-circle-close" @click="boxClose"></i> -->
            <span class="question-close" @click="boxClose">×</span>
          </div>
        </div>
      </div>
    </transition>
    <transition name="el-fade-in">
      <div v-show="question_box_show" class="question_box">
        <div class="question">
          <div class="head">
            新品展示小问答
            <!-- <i class="el-icon-circle-close" @click="boxClose"></i> -->
            <span class="question-close" @click="boxClose">×</span>
          </div>
          <div class="container">
            <div class="title">
              <img class="icon" :src="Res_Url + '/exhibition/question_title_icon.png'" alt="" />{{
                question.title }}
            </div>
            <el-radio-group v-if="question.title.indexOf('多选') === -1" v-model="currentSelect">
              <el-radio v-for="(item, index) in question.select" :key="item" :label="index">{{ item }}</el-radio>
            </el-radio-group>
            <el-checkbox-group v-else v-model="currentSelect">
              <el-checkbox v-for="(item, index) in question.select" :key="index" :value="item" :label="index">{{ item
              }}</el-checkbox>
            </el-checkbox-group>
            <div class="btns">
              <div class="cancel" @click="boxClose">返回新品展示</div>
              <div class="confirm" @click="confirm">提交</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <Rdialog :articleCode="articleCode" :isRegister="isRegister" :isEmail="isEmail" @handleClose="handleClose"
      @handleEmail="handleEmail" :isIntegral="isIntegral" :integralText="integralText"></Rdialog>
    <Qdialog :isSuccess="isSuccess" :isOk="isOk" :isError="isError" @handleClose="handleClose"
      @handleReset="handleReset"></Qdialog>
    <!-- 音频 -->
    <div class="audioBox">
      <audio controls ref="audioEle" @timeupdate="updateProgress">
        <source :src="audios[active]">
      </audio>
    </div>
  </div>
</template>

<script>
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  Navigation,
  EffectFade,
} from "swiper/core";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.min.css";
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation, EffectFade]);
import Rdialog from "@/components/rdialog/index.vue";
import Qdialog from "@/components/qdialog/index.vue";
import { Res_Url, Res_Url2026 } from "@/utils/ApiToken.js";
import {
  AddPoints,
  SubmitNewProduct,
  SubmitNewProductPost,
  GetUserLogs,
} from "../../api/index.js";
import cloudGuideData from "@/assets/json/cloudGuide.json";
// import { forEach } from "core-js/core/array";

export default {
  data() {
    const that = this;
    return {
      Res_Url: Res_Url,
      Res_Url2026: Res_Url2026,
      cloudGuideData,
      banner_title: "工业自动化",
      // 静态资源图片
      imgs: {
        arrow_up: Res_Url + "/exhibition/arrow_up.png",
        arrow_down: Res_Url + "/exhibition/arrow_down.png",
        download: Res_Url + "/exhibition/download.png",
        exam: Res_Url + "/exhibition/exam.png",
        pause: Res_Url + "/common/audio-pause.png",
        play: Res_Url + "/common/audio-playing.png",
      },
      banner: Res_Url2026 + "/exhibition/banner.png",
      banner_m: Res_Url2026 + "/exhibition/banner_m.png",
      tabs: [
        {
          id: 0,
          icon: Res_Url2026 + "/cloudGuide/tab0_on.png",
          icon_active: Res_Url2026 + "/cloudGuide/tab0_off.png",
          name: "流程/混合行业",
        },
        {
          id: 1,
          icon: Res_Url2026 + "/cloudGuide/tab1_on.png",
          icon_active: Res_Url2026 + "/cloudGuide/tab1_off.png",
          name: "离散行业",
        },
        {
          id: 2,
          icon: Res_Url2026 + "/cloudGuide/tab2_on.png",
          icon_active: Res_Url2026 + "/cloudGuide/tab2_off.png",
          name: "数据中心行业",
        },
        {
          id: 3,
          icon: Res_Url2026 + "/cloudGuide/tab3_on.png",
          icon_active: Res_Url2026 + "/cloudGuide/tab3_off.png",
          name: "市政行业",
        },
        {
          id: 4,
          icon: Res_Url2026 + "/cloudGuide/tab4_on.png",
          icon_active: Res_Url2026 + "/cloudGuide/tab4_off.png",
          name: "咨询",
        },
        {
          id: 5,
          icon: Res_Url2026 + "/cloudGuide/tab5_on.png",
          icon_active: Res_Url2026 + "/cloudGuide/tab5_off.png",
          name: "工控邦",
        },


      ],
      active: 0,
      video_box_show: false,
      currentVideo: "",
      img_box_show: false,
      currentImg: "",
      pageIndex: 1,
      swiperOption: {
        direction: "horizontal",
        // autoplay: {
        //   delay: 5000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        // loop: true,
        // slidesPerView: 1.25,
        centeredSlides: true,
        spaceBetween: 40,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChange: (swiper) => {
            that.pageIndex = swiper.activeIndex + 1;
          },
        },
      },
      isRegister: false,
      isEmail: false,
      question_box_show: false,
      question: {
        title: "如下哪个不是施耐德电气 EcoStruxure™ 开放自动化平台的正确表述？",
        select: [
          "A.促进100%的工程效率",
          "B.实现100%的运营效率",
          "C.应对100%的未来挑战",
          "D.完成100%的工作任务",
        ],
        answer: 0,
      },
      currentSelect: -1,
      isSuccess: false,
      isOk: false,
      isError: false,
      articleCode: "",
      activeShow: 0,
      cards: [],
      questionType: "radio",
      isIntegral: false,
      integralText: "",
      // 语音导览
      audioIndex: 0,
      playing: false,
      audios: [
        'https://staticdn.ht-s.cn/se/ciif/2024/cloudGuide/gykcx.mp3',
        'https://staticdn.ht-s.cn/se/ciif/2024/cloudGuide/kfzdh.mp3',
        'https://static.wechat.schneider-electric.cn/focus/Upload/Resouse/c04e8f2e-e310-49d0-b9ee-e33a21af2f9d.mp3'
      ]
    };
  },
  components: {
    Swiper,
    SwiperSlide,
    Rdialog,
    Qdialog,
  },
  created() {
    this.$store.commit("load", true);
    this.cloudGuideDataCopy = JSON.parse(JSON.stringify(this.cloudGuideData));
    // 切换到对应tab
    this.active = Number(this.$route.query.tab)
      ? Number(this.$route.query.tab)
      : 0;
    // 选中默认播放音频
    this.audioIndex = this.active;

    this.banner_title = this.tabs[this.active].name;
    this.cards =
      this.active === 7
        ? this.cloudGuideDataCopy.utilConstr
        : this.active === 6
          ? this.cloudGuideDataCopy.recyCirc
          : this.active === 5
            ? this.cloudGuideDataCopy.waterEnv
            : this.active === 4
              ? this.cloudGuideDataCopy.packLog
              : this.active === 3
                ? this.cloudGuideDataCopy.consumMfg
                : this.active == 2
                  ? this.cloudGuideDataCopy.fineChemNM
                  : this.active == 1
                    ? this.cloudGuideDataCopy.oilRefining
                    : this.cloudGuideDataCopy.Interactive;

    // // 滚动到指定区域
    if (this.$route.query.title) {
      let i = this.cards.findIndex(
        (item) => item.title === this.$route.query.title
      );
      let card = JSON.parse(JSON.stringify(this.cards[i]));
      this.cards.splice(i, 1);
      this.cards.unshift(card);
    }
  },
  mounted() {
    GetUserLogs({
      visitName: "页面访问-云导览",
      visitType: 1,
      url: window.location.href,
      track: this.$route.query.track ? this.$route.query.track : 11058,
    });
  },
  methods: {
    // 语音导览,播放
    playAudio(index, status, time) {
      var that = this;
      let audioIndex = this.audioIndex;
      const audio = this.$refs.audioEle;
      console.log(index, status, time);
      if (status) {
        audio.pause();
        this.playing = false;
        setTimeout(function () {
          that.cards[index].audio.play = false;
        }, 300);
      } else {
        for (var i = 0; i < this.cards.length; i++) {
          if (this.cards[i].audio) {
            this.cards[i].audio.play = false;
          }
        }
        let [startTime, endTime] = this.parseTimeRangeToSeconds(time);
        audio.currentTime = startTime;
        audio.play();
        this.cards[index].audio.play = true;
        this.playing = true;

      }
    },
    updateProgress(event) {
      const audio = event.target;
      console.log(audio.currentTime);
      for (var i = 0; i < this.cards.length; i++) {
        if (this.cards[i].audio) {
          let [startTime, endTime] = this.parseTimeRangeToSeconds(this.cards[i].audio.time);
          this.cards[i].audio.play = false;
          if (audio.currentTime >= startTime && audio.currentTime <= endTime && audio.currentTime != 0) {
            this.cards[i].audio.play = true;
            this.audioIndex = i;
          }
        }
      }
    },
    parseTimeRangeToSeconds(timeRange) {
      // 使用'-'分割时间范围字符串得到起始时间和结束时间
      const times = timeRange.split('-');
      const startTime = times[0].split(':').reduce((acc, cur, index) => {
        // 第一部分是分钟，第二部分是秒
        return acc + parseInt(cur) * (index === 0 ? 60 : 1);
      }, 0);

      const endTime = times[1].split(':').reduce((acc, cur, index) => {
        // 第一部分是分钟，第二部分是秒
        return acc + parseInt(cur) * (index === 0 ? 60 : 1);
      }, 0);

      return [startTime, endTime];
    },

    videoPlay(item) {
      const obj = { event: "trk", ec: "product", ea: "videoplay" };
      dataLayer.push(JSON.parse(JSON.stringify(obj)))
      this.currentVideo = item.content;
      this.video_box_show = true;
    },
    imgPreview(item) {
      (this.currentImg = item.content), (this.img_box_show = true);
    },
    handleLink(item) {
      window.open(item.linkUrl)
    },
    boxClose() {
      const obj = {
        event: "trk",
        ec: "popup",
        ea: "close",
        el: "close",
      };
      dataLayer.push(JSON.parse(JSON.stringify(obj)))
      this.video_box_show = false;
      this.img_box_show = false;
      this.question_box_show = false;
      this.currentVideo = "";
      this.currentImg = "";
    },
    toExam(item) {
      if (this.$store.state.islogin) {
        this.articleCode = item.code;
        if (item.question.title.indexOf("多选") === -1) {
          this.questionType = "radio";
          this.currentSelect = -1;
        } else {
          this.currentSelect = [];
          this.questionType = "checkbox";
        }
        SubmitNewProduct(item.code).then((res) => {
          if (res.Status === 1) {
            this.question = JSON.parse(JSON.stringify(item.question));
            this.question_box_show = true;
          } else {
            this.isSuccess = true;
          }
        });
      } else {
        this.isRegister = true;
      }
    },
    isShow(item, index) {
      if (this.activeShow != index) {
        this.pageIndex = 1;
        this.activeShow = index;
      } else {
        this.activeShow = -1;
      }
    },
    confirm() {
      if (this.currentSelect !== -1 && this.currentSelect.length !== 0) {
        this.$store.commit("load", true);
        let answer = "";
        if (typeof this.currentSelect === "number") {
          switch (this.currentSelect) {
            case 0:
              answer = "A";
              break;
            case 1:
              answer = "B";
              break;
            case 2:
              answer = "C";
              break;
            case 3:
              answer = "D";
              break;
            case 4:
              answer = "E";
              break;
            case 5:
              answer = "F";
              break;
            case 6:
              answer = "G";
              break;
            case 7:
              answer = "H";
              break;
          }
        } else {
          this.currentSelect = this.currentSelect.join(",");
          this.currentSelect = this.currentSelect.replace("0", "A");
          this.currentSelect = this.currentSelect.replace("1", "B");
          this.currentSelect = this.currentSelect.replace("2", "C");
          this.currentSelect = this.currentSelect.replace("3", "D");
          this.currentSelect = this.currentSelect.replace("4", "E");
          this.currentSelect = this.currentSelect.replace("5", "F");
          this.currentSelect = this.currentSelect.replace("6", "G");
          this.currentSelect = this.currentSelect.replace("7", "H");
          answer = this.currentSelect;
        }

        this.question_box_show = false;
        SubmitNewProductPost(
          {
            answer: answer,
            answerCode: this.articleCode,
          },
          this.$route.query.track
        ).then((res) => {
          setTimeout(() => {
            this.$store.commit("load", false);
            if (res.Status === 1) {
              this.isError = true;
            } else if (res.Status === 2) {
              this.isOk = true;
            }
          }, 500);
        });
      } else {
        this.$toast("请选择一个选项！");
      }
    },
    handleClose() {
      this.isSuccess = false;
      this.isOk = false;
      this.isError = false;
      this.isEmail = false;
      this.isRegister = false;
      this.isIntegral = false;
    },
    handleReset() {
      this.isError = false;
      if (this.questionType === "radio") {
        this.currentSelect = -1;
      } else {
        this.currentSelect = [];
      }
      this.question_box_show = true;
    },
    download(item) {
      if (this.$store.state.islogin) {
        this.articleCode = item.code;
        this.isEmail = true;
      } else {
        this.isRegister = true;
      }
    },
    handleEmail(e) {
      AddPoints({
        visitType: 25,
        track: this.$route.query.track ? this.$route.query.track : "",
        name: this.articleCode,
        email: e,
      }).then((res) => {
        if (res.Status === 1) {
          this.isEmail = false;
          this.isIntegral = true;
          if (res.Data === "1") {
            this.integralText = res.Message;
          } else {
            this.integralText = "恭喜您，下载成功";
          }
        }
      });
    },
    tabChange(item, index) {
      let that = this;
      var obj;
      if (index == 0) {
        obj = { event: "trk", ec: "tab", ea: "ProcessMixed" };
      }
      else if (index == 1) {
        obj = { event: "trk", ec: "tab", ea: "DiscreteIndustry" };
      } else if (index == 2) {
        obj = { event: "trk", ec: "tab", ea: "dataCentre" };
      } else if (index == 3) {
        obj = { event: "trk", ec: "tab", ea: "waterReg" };
      } else if (index == 4) {
        obj = { event: "trk", ec: "tab", ea: "consult" };
      } else if (index == 5) {
        obj = { event: "trk", ec: "tab", ea: "control" };
      }
      // else if (index == 6) {
      //   obj = { event: "trk", ec: "tab", ea: "recyCirc" };
      // } else if (index == 7) {
      //   obj = { event: "trk", ec: "tab", ea: "utilConstr" };
      // }
      // 暂停音频播放
      if (this.playing) {
        const audio = this.$refs.audioEle;
        audio.pause();
        this.cards[this.audioIndex].audio.play = false;
        this.playing = false;
      }
      // var ga_Code = JSON.parse(JSON.stringify(obj));
      // dataLayer.push(ga_Code);
      this.cards =
        index === 7
          ? this.cloudGuideDataCopy.utilConstr
          : index === 6
            ? this.cloudGuideDataCopy.recyCirc
            : index === 5
              ? this.cloudGuideDataCopy.waterEnv
              : index === 4
                ? this.cloudGuideDataCopy.packLog
                : index === 3
                  ? this.cloudGuideDataCopy.consumMfg
                  : index == 2
                    ? this.cloudGuideDataCopy.fineChemNM
                    : index == 1
                      ? this.cloudGuideDataCopy.oilRefining
                      : this.cloudGuideDataCopy.Interactive;
      this.active = index;
      this.banner_title = item.name;
      this.$nextTick(() => {
        this.$refs.audioEle.load();
      });
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>